import React from 'react';
import CustomDatePicker from 'components/Input/CustomDatePicker';
import styled from 'styled-components';
import CustomOutlineSelect from 'components/Input/CustomOutlineSelect';
import { typeOfReview } from 'constants/globalEnum';
import moment from 'moment';
const SRow = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    & > div:nth-child(1) {
        width: 200px;
        flex-shrink: 0;
        font-weight: bold;
    }

    & > div:nth-child(2) {
        width: 400px;
    }
`;

export default function TextFieldContainer({ isEditMode, handleSave, saveData, forceErrorDisplay }) {
    const handleChangeValue = (name, value) => {
        handleSave({ ...saveData, [name]: value });
    };

    return (
        <div>
            <SRow>
                <div>Type of Review:</div>
                <div>
                    {isEditMode ? (
                        <CustomOutlineSelect
                            value={saveData.typeOfReview}
                            onChange={(e) => handleChangeValue('typeOfReview', e.target.value)}
                            choices={typeOfReview}
                            label="Type of Review"
                            isRequired
                            forceErrorDisplay={forceErrorDisplay}
                        />
                    ) : (
                        typeOfReview.find((item) => item.key === saveData.typeOfReview)?.display || '-'
                    )}
                </div>
            </SRow>
            <SRow>
                <div>Review Due Date:</div>
                <div>
                    <CustomDatePicker
                        label="Review Due Date"
                        value={saveData.reviewDueDate} //new Date(value)
                        onChange={(date) => handleChangeValue('reviewDueDate', new Date(date))}
                    />

                    {/* {isEditMode ? (
                        <CustomDatePicker
                            label="Review Due Date"
                            value={saveData.reviewDueDate} //new Date(value)
                            onChange={(date) => handleChangeValue('reviewDueDate', new Date(date))}
                        />
                    ) : saveData.reviewDueDate ? (
                        moment(saveData.reviewDueDate).format('YYYY-MM-DD')
                    ) : (
                        '-'
                    )} */}
                </div>
            </SRow>
            <SRow>
                <div>Review Meeting Date:</div>
                <div>
                    <CustomDatePicker
                        label="Review Meeting Date"
                        value={saveData.reviewMeetingDate}
                        onChange={(date) => handleChangeValue('reviewMeetingDate', new Date(date))}
                    />
                    {/* {isEditMode ? (
                        <CustomDatePicker
                            label="Review Meeting Date"
                            value={saveData.reviewMeetingDate}
                            onChange={(date) => handleChangeValue('reviewMeetingDate', new Date(date))}
                        />
                    ) : saveData.reviewMeetingDate ? (
                        moment(saveData.reviewMeetingDate).format('YYYY-MM-DD')
                    ) : (
                        '-'
                    )} */}
                </div>
            </SRow>
            <SRow>
                <div>Review Circulation Date:</div>
                <div>
                    <CustomDatePicker
                        label="Review Circulation Date"
                        value={saveData.reviewCirculationDate}
                        onChange={(date) => handleChangeValue('reviewCirculationDate', new Date(date))}
                    />
                    {/* {isEditMode ? (
                        <CustomDatePicker
                            label="Review Circulation Date"
                            value={saveData.reviewCirculationDate}
                            onChange={(date) => handleChangeValue('reviewCirculationDate', new Date(date))}
                        />
                    ) : saveData.reviewCirculationDate ? (
                        moment(saveData.reviewCirculationDate).format('YYYY-MM-DD')
                    ) : (
                        '-'
                    )} */}
                </div>
            </SRow>
            {/* <SRow>
                <div>Review Panel:</div>
                <div>
                    <CustomOutlineSelect
                        value={'0'}
                        onChange={(e) => {}}
                        choices={[
                            { key: '0', display: 'Panel 1' },
                            { key: '1', display: 'Panel 2' },
                        ]}
                        placeholder={'Please choose your decision'}
                    />
                </div>
            </SRow> */}
        </div>
    );
}
